import React, { useState } from 'react';

import Layout from '../../layout/Layout';
import ListingInfo from './components/ListingInfo';
import CarsList from './components/CarsList';
import CompatibilityModal from '../../components/CompatibilityModal/CompatibilityModal';
import CompatibilitySubheader from './components/CompatibilitySubheader';

const layoutContainerClassName = 'flex flex-1 flex-col lg:flex-row gap-[20px]';

const Compatibility = () => {
  const [sourceId, setSourceId] = useState('');
  const [compatibilityModal, setCompatibilityModal] = useState(false);

  return (
    <Layout pageTitle="Compatibility" subheader={<CompatibilitySubheader />}>
      <div className={layoutContainerClassName}>
        <ListingInfo
          sourceId={sourceId}
          setSourceId={setSourceId}
          onItemPress={() => setCompatibilityModal(true)}
        />
        <div className="flex-[3]">
          <CarsList
            openModal={() => setCompatibilityModal(true)}
          />
        </div>
      </div>
      <CompatibilityModal
        visible={compatibilityModal}
        toggleVisible={() => setCompatibilityModal(false)}
      />
    </Layout>
  );
};

Compatibility.propTypes = {};

Compatibility.defaultProps = {};

export default Compatibility;
